var map = {
	"./charleston-advisor.png": "3b52",
	"./charleston-hub.png": "4a6a",
	"./research-information-2.png": "f8c2",
	"./research-information.png": "3188",
	"./scholarly-kitchen.png": "baf9",
	"./science.png": "9b6d",
	"./sparc.png": "37c6f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3600";